import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 1.333H6.667a2 2 0 0 0-2 2V8a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2M14 8a.667.667 0 0 1-.667.667H6.667A.667.667 0 0 1 6 8V3.333a.667.667 0 0 1 .667-.666h6.666a.667.667 0 0 1 .667.666zm-2.333-2.667a1 1 0 0 0-.667.26 1 1 0 1 0 0 1.48 1 1 0 1 0 .667-1.74m-1 6A.667.667 0 0 0 10 12v.667a.667.667 0 0 1-.667.666H2.667A.667.667 0 0 1 2 12.667V10h.667a.667.667 0 1 0 0-1.333H2V8a.667.667 0 0 1 .667-.667.667.667 0 1 0 0-1.333 2 2 0 0 0-2 2v4.667a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V12a.667.667 0 0 0-.666-.667M4 12h.667a.667.667 0 1 0 0-1.333H4A.666.666 0 1 0 4 12"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })